import { UseGetStoreData } from "../getStoreData/UseGetStoreData";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ticketUpdateStatusSuccess } from "../../redux/ticketUpdateSlice/ticketUpdateSlice";
import { fareCalculationApi } from "../../http";


export const useSelectAssistance=(ambulanceData: any)=>{
    const dispatch = useDispatch();
    const {getTicketUpdateData, getAmbulanceDistanceBetween}=UseGetStoreData();
    const [selectedValues, setSelectedValues] = useState<{
      [key: string]: boolean | number;
    }>({});
    const [numberOfHelpers, setNumberOfHelpers] = useState<number>(0);
    
    // Update state when ambulance data loads
    useEffect(() => {
      
        const ambulanceItem = ambulanceData?.[0];
        if (ambulanceItem) {
            const restoredHelpers = ambulanceItem?.typeOfAssistanceRequired?.numberofHelper || 0;
            const newSelectedValues = {
                wheelChair: ambulanceItem?.typeOfAssistanceRequired?.wheelChair || false,
                stretcher: ambulanceItem?.typeOfAssistanceRequired?.stretcher || false,
                paramedic: ambulanceItem?.typeOfAssistanceRequired?.paramedic|| false,
                additionalHelp: ambulanceItem?.typeOfAssistanceRequired?.additionalHelp || false,
                DoctorOnBoard: ambulanceItem?.typeOfAssistanceRequired?.DoctorOnBoard || false,
            };
            setSelectedValues(newSelectedValues);
            setNumberOfHelpers(restoredHelpers);
            dispatch(ticketUpdateStatusSuccess({
                typeOfAssistanceRequired: {
                    ...newSelectedValues,
                    numberOfHelpers: restoredHelpers,
                }
            }));
        }
    }, [ambulanceData, dispatch]);

    const callFareCalculation = async (assistanceValues: any) => {
        const rateCardName = getTicketUpdateData?.selectedPocoRateCard;
        const ambulanceType = getTicketUpdateData?.selectedAmbulanceType;
        
        if (!rateCardName || !ambulanceType || !getAmbulanceDistanceBetween) return;
        
        const distanceMatch = getAmbulanceDistanceBetween?.match(/[\d.]+/);
        const distance = distanceMatch ? parseFloat(distanceMatch[0]) : 0;
        
        try {
            const result = await fareCalculationApi({
                ambulanceType,
                distance,
                rateCardName,
                assistanceRequired: {
                    wheelChair: assistanceValues.wheelChair || false,
                    stretcher: assistanceValues.stretcher || false,
                    paramedic: assistanceValues.paramedic || false,
                    DoctorOnBoard: assistanceValues.DoctorOnBoard || false,
                    numberOfHelpers: assistanceValues.numberOfHelpers || 0
                }
            });
            
            const fareData = result.data?.data;
            const extraCharges = fareData?.extraCharges || 0;
            
            dispatch(ticketUpdateStatusSuccess({
                extraCharges
            }));
        } catch (error) {
            console.error("Error calling fare calculation API:", error);
        }
    };
    
    const handleOptionChange = async (event: any) => {
      let value = event.target.value;
      const isSelected = !selectedValues[value];
  
      if (value === "additionalHelp" && !isSelected) {
        setNumberOfHelpers(0);
      }

      const newValues = {
        ...selectedValues,
        [value]: isSelected,
        numberOfHelpers: value === "additionalHelp" && !isSelected ? 0 : numberOfHelpers
      };
      
      setSelectedValues(newValues);
      
      dispatch(ticketUpdateStatusSuccess({
        typeOfAssistanceRequired: newValues
      }));
      
      await callFareCalculation(newValues);
    };
    
    useEffect(()=>{
        setSelectedValues((prevState)=>({...prevState,paramedic: getTicketUpdateData?.currentMedicalStatusResponse?.isPatientConscious?.toLowerCase() === "no" ? true : false || false,}))
    },[getTicketUpdateData?.currentMedicalStatusResponse])

    const handleNumberOfHelpersChange = async (value: string) => {
        const num = parseInt(value) || 1;
        setNumberOfHelpers(num);
        
        const newValues = {
          ...selectedValues,
          numberOfHelpers: num
        };
        
        setSelectedValues(newValues);
        
        dispatch(ticketUpdateStatusSuccess({
          typeOfAssistanceRequired: newValues
        }));
        
        await callFareCalculation(newValues);
    };

    return{
        selectedValues,
        handleOptionChange,
        numberOfHelpers,
        handleNumberOfHelpersChange,
        getTicketUpdateData
      }
}
